import React from 'react'

const IconImageTool = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <rect x='3' y='4' width='18' height='16' rx='1.5' />
         <circle cx='8.5' cy='9.5' r='1.5' />
         <path d='M21 16l-5.5-5.5L4 21' />
      </svg>
   )
}
export default IconImageTool
